import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import Sidebar from '../sidebar/sidebar'
import styles from './container.module.scss'

function Container({ children }) {
    const { t, i18n } = useTranslation();
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => {
            window.removeEventListener('resize', checkMobile);
        };
    }, []);

    return (
        <div className={`${styles.container} ${i18n.language === 'ar' ? styles.container_ar : ''}`}>
            <div className={styles.mainContainer}>
                {children}
            </div>

            <aside className={styles.sidebar}>
                <Sidebar isMobile={isMobile} />
            </aside>
        </div>
    )
}

export default Container